import React, { ComponentPropsWithRef, FC } from 'react';
import { useAuthModal } from '@auth/business/AuthModal.hook';
import { PrimaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { Text } from '@components/Text/Text.component';
import { PlcAnchor } from '@layout/components/PlcAnchor/PlcAnchor.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { urlEnum } from '@utils/url';
import classnames from 'classnames';
import styles from './Comment.module.scss';

const CommentsNotLoggedIn: FC<ComponentPropsWithRef<'div'>> = ({ className, ...rest }) => {
  const rootClass = classnames(styles.commentsNotLoggedIn, className);
  const { showSignInModal } = useAuthModal();

  const isButtonSmall = useIsBreakpointDown(Breakpoint.l);

  return (
    <div className={rootClass} {...rest}>
      <Text
        alignment="center"
        className={styles.commentNotLoggedInText}
        i18nKey="actu.comments.not-logged-in"
        tag="div"
        variant="new-p"
      />
      <div>
        <PlcAnchor linkProps={{ href: urlEnum.signUp }}>
          <PrimaryButton isLightGreen isSmall={isButtonSmall} textProps={{ i18nKey: 'auth.sign-up.link' }} />
        </PlcAnchor>
        <PrimaryButton
          isLightGreen
          isSmall={isButtonSmall}
          onClick={() => showSignInModal()}
          textProps={{ i18nKey: 'auth.connect' }}
        />
      </div>
    </div>
  );
};

export { CommentsNotLoggedIn };
